import React from 'react';

export const parseData = (data) => ({
  maxSelections: data.maxSelections,
  deviceCategories: Object.freeze(data.deviceCategories),
  statusCode200: Object.freeze(data.statusCode200),
  statusCodeError: Object.freeze(data.statusCodeError),
  headerMessage: Object.freeze(data.headerMessage),
});

const BOLD_RE = /^<b>(.*?)<\/b>$/;
const ANCHOR_RE = /^<a\s+href="([^"]*)"[^>]*>(.*?)<\/a>$/;
const SAFE_HREF_RE = /^https?:\/\//i;
const TOKEN_RE = /<b>.*?<\/b>|<a\s+href="[^"]*"[^>]*>.*?<\/a>/g;

const parseToken = (token, key) => {
  const boldMatch = BOLD_RE.exec(token);
  if (boldMatch) {
    return <b key={key}>{boldMatch[1]}</b>;
  }

  const anchorMatch = ANCHOR_RE.exec(token);
  if (anchorMatch) {
    const href = anchorMatch[1];
    if (SAFE_HREF_RE.test(href)) {
      return (
        <a key={key} href={href} target="_blank" rel="noopener noreferrer">
          {anchorMatch[2]}
        </a>
      );
    }
    return anchorMatch[2];
  }

  return token;
};

export const parseRichText = (str) => {
  if (typeof str !== 'string') return str;

  const matches = Array.from(str.matchAll(new RegExp(TOKEN_RE.source, 'g')));

  const { parts, lastIndex } = matches.reduce(
    (acc, match) => {
      const before = match.index > acc.lastIndex
        ? [str.slice(acc.lastIndex, match.index)]
        : [];
      return {
        parts: [...acc.parts, ...before, parseToken(match[0], match.index)],
        lastIndex: match.index + match[0].length,
      };
    },
    { parts: [], lastIndex: 0 },
  );

  const tail = lastIndex < str.length ? [str.slice(lastIndex)] : [];
  const result = [...parts, ...tail];

  return result.length === 0 ? str : result;
};
